import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {Text} from "components/form";
import {AddOutboundPrivateLinkDnsRecordRequest} from "~/client/resources/addOutboundPrivateLinkDnsRecordRequest";

interface Props {
    instanceId: string;
    onTaskStarted: (taskId: string) => void;
}

interface State extends DataBaseComponentState {
    request: AddOutboundPrivateLinkDnsRecordRequest;
}

class AddOutboundPrivateLinkDnsRecordDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            request: {
                PrivateDnsZoneName: "",
                DnsRecordName: ""
            }
        };
    }

    render() {
        return <SaveDialogLayout title={"Add Outbound Private Link DNS Record"}
            onSaveClick={() => this.provision()}
            errors={this.state.errors}
            saveButtonLabel={"Provision"}
            busy={this.state.busy}>
            <Text label="Private DNS Zone Name"
                value={this.state.request.PrivateDnsZoneName}
                hintText={"e.g. mydomain.com"}
                onChange={PrivateDnsZoneName => this.modifyRequestState({PrivateDnsZoneName})}
            />
            <Text label="Record Set Name (Sub Domain)"
                value={this.state.request.DnsRecordName}
                hintText={"e.g. subdomain"}
                onChange={DnsRecordName => this.modifyRequestState({DnsRecordName: DnsRecordName})}
            />
        </SaveDialogLayout>;
    }

    private modifyRequestState(request: Partial<AddOutboundPrivateLinkDnsRecordRequest>): void {
        this.setState((prevState: State) => ({request: {...prevState.request, ...request}}));
    }

    private async provision(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const taskId = await repository.HostedInstances.addOutboundPrivateLinkDnsRecord(this.props.instanceId, this.state.request);
            this.props.onTaskStarted(taskId);
        });
    }
}

export default AddOutboundPrivateLinkDnsRecordDialog;
